import React from 'react';
import { Shield, User } from 'lucide-react';
interface ChatBubbleProps {
  message: string;
  sender: 'bot' | 'user';
  timestamp?: string;
}
export function ChatBubble({
  message,
  sender,
  timestamp
}: ChatBubbleProps) {
  const isBot = sender === 'bot';
  const time = timestamp || new Date().toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit'
  });
  return <div className={`
        flex w-full mb-4 sm:mb-6 animate-slide-up
        ${isBot ? 'justify-start' : 'justify-end'}
      `} data-id="element-56">
      <div className={`
          flex max-w-[90%] sm:max-w-[80%] md:max-w-[70%]
          ${isBot ? 'flex-row' : 'flex-row-reverse'}
        `} data-id="element-57">
        {/* Avatar */}
        <div className="flex-shrink-0 self-end mb-1" data-id="element-58">
          <div className={`
              w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center shadow-sm
              ${isBot ? 'bg-gradient-to-br from-primary-50 to-primary-100 text-primary-700 mr-2 sm:mr-3 border border-primary-200' : 'bg-gradient-to-br from-slate-100 to-slate-200 text-slate-600 ml-2 sm:ml-3 border border-slate-200'}
            `} data-id="element-59">
            {isBot ? <Shield className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-60" /> : <User className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-61" />}
          </div>
        </div>

        {/* Message Bubble Container */}
        <div className={`flex flex-col ${isBot ? 'items-start' : 'items-end'}`} data-id="element-62">
          {/* Bubble */}
          <div className={`
              relative px-4 py-3 sm:px-5 sm:py-4 text-sm sm:text-base leading-relaxed shadow-sm transition-all duration-200
              ${isBot ? 'bg-white text-slate-800 rounded-2xl rounded-bl-none border border-slate-200 hover:border-slate-300' : 'bg-primary-600 text-white rounded-2xl rounded-br-none shadow-md hover:bg-primary-700'}
            `} data-id="element-63">
            {message}
          </div>

          {/* Timestamp */}
          <span className="text-[10px] sm:text-xs text-slate-400 mt-1 px-1 opacity-0 hover:opacity-100 transition-opacity select-none" data-id="element-64">
            {time}
          </span>
        </div>
      </div>
    </div>;
}